export const GET_UNIT_BY_ID_REQUEST = 'GET_UNIT_BY_ID_REQUEST';
export const GET_UNIT_BY_ID_SUCCESS = 'GET_UNIT_BY_ID_SUCCESS';
export const GET_UNIT_BY_ID_FAILURE = 'GET_UNIT_BY_ID_FAILURE';

export const GET_APPOINTMENTS_BY_ID_REQUEST = 'GET_APPOINTMENTS_BY_ID_REQUEST';
export const GET_APPOINTMENTS_BY_ID_SUCCESS = 'GET_APPOINTMENTS_BY_ID_SUCCESS';
export const GET_APPOINTMENTS_BY_ID_FAILURE = 'GET_APPOINTMENTS_BY_ID_FAILURE';
export const RESET_APPOINTMENTS = 'RESET_APPOINTMENTS';
